export default __webpack_public_path__ + "static/mail-142-22b2abef96fda018215b86fb0e379d24.png";